/**
 * Shared CrewPilot centered-dialog chrome (inline style fingerprint).
 *
 * Canonical ordinary dialog:
 * - overlay: fixed full-screen dimmer @ z-index 9999
 * - panel: #0b1220, gold border, 16px radius
 *
 * Viewport attachment (portal + scroll lock + sheet/center) lives in
 * ViewportDialog.js. These constants remain the centered-dialog skin for
 * confirms that ViewportPortal lifts out of `.screen`. Callers may pass
 * overrides for maxWidth / zIndex / padding without inventing a parallel skin.
 *
 * Do not use for sheets (np-overlay, HubSort), PDF, Ashley, or product-education.
 */

export const CP_MODAL_Z_INDEX = 9999;

export const CP_MODAL_OVERLAY_STYLE = {
  position: "fixed",
  inset: 0,
  background: "rgba(0, 0, 0, 0.75)",
  zIndex: CP_MODAL_Z_INDEX,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
};

export const CP_MODAL_PANEL_STYLE = {
  width: "100%",
  maxWidth: "420px",
  background: "#0b1220",
  border: "1px solid rgba(201, 168, 76, 0.25)",
  borderRadius: "16px",
  padding: "20px",
  color: "white",
};

export function cpModalOverlayStyle(overrides = {}) {
  return { ...CP_MODAL_OVERLAY_STYLE, ...overrides };
}

export function cpModalPanelStyle(overrides = {}) {
  return { ...CP_MODAL_PANEL_STYLE, ...overrides };
}
